import React, { useId } from 'react';
interface TextFieldProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  label: string;
  value: string;
  onChange: (v: string) => void;
  error?: string;
  help?: string;
  multiline?: boolean;
  dark?: boolean;
}
export function TextField({
  label,
  value,
  onChange,
  error,
  help,
  multiline,
  dark,
  className,
  ...rest
}: TextFieldProps) {
  const id = useId();
  const describedBy = error ? `${id}-err` : help ? `${id}-help` : undefined;
  const base = `w-full rounded-lg border-2 px-4 text-base transition-[border-color] duration-150 ease-out focus:outline-none ${dark ? 'bg-ink-800 text-white placeholder:text-ink-400 border-ink-600 focus:border-lime' : 'bg-white text-ink placeholder:text-ink-400 focus:border-ink'} ${error ? 'border-magenta' : dark ? '' : 'border-ink-200'}`;
  return <div className={className} data-id="element-996" data-mp="30falcf7v1ppt">
      <label htmlFor={id} className={`mb-1.5 block text-sm font-semibold ${dark ? 'text-white' : 'text-ink'}`} data-id="element-997" data-mp="2wfa5qr90z8h6">
        {label}
      </label>
      {multiline ? <textarea id={id} value={value} onChange={e => onChange(e.target.value)} rows={3} aria-invalid={!!error} aria-describedby={describedBy} className={`${base} py-3`} data-id="element-998" data-mp="374gbancv97ve" /> : <input id={id} value={value} onChange={e => onChange(e.target.value)} aria-invalid={!!error} aria-describedby={describedBy} className={`${base} h-12`} {...rest} data-id="element-999" data-mp="3g6xusu14zmep" />}
      {error ? <p id={`${id}-err`} className="mt-1.5 text-sm font-medium text-magenta-dark" data-id="element-1000" data-mp="2ofrofvutosgz">
          {error}
        </p> : help ? <p id={`${id}-help`} className={`mt-1.5 text-sm ${dark ? 'text-ink-300' : 'text-ink-500'}`} data-id="element-1001" data-mp="2sdpfl485lon0">
          {help}
        </p> : null}
    </div>;
}